import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => {
    return {
      loaded: construction.parameters_loaded,
      roofing_available: [...construction.available.roofing],
      roofing_info: construction.info.roofing,
      roofing_selected: construction.selected.roofing,
      roofing_placement_available: [...construction.available.roofing_placement],
      roofing_placement_selected: construction.selected.roofing_placement,
      //@todo task 3
      // roofing_construction_additive_available: [...construction.available.roofing],
      // roofing_construction_additive_info: construction.info.roofing,
      // roofing_construction_additive_selected: construction.selected.roofing,
    };
  }
);
